/* ==========================================================================
   MAXIMA – a "Kollekciók" mega menü Maxima paneljének viselkedése (V2).
   Bal (2. oszlop): fő kategória tabok. Jobb: az aktív fő kategória alkategóriái.

   Váltás: INDEX-alapú és a legközelebbi [data-maxima-menu] KOMPONENSRE scoped.
   NEM használ document.getElementById-et és NEM az id/aria-controls egyezést –
   így a sticky-header KLÓN által okozott duplikált ID-k sem zavarják meg.
   Az id/aria-controls megmarad accessibility célra, de nem vezérli a váltást.

   Document-szintű esemény-delegálás (az AJAX-injektált és klónozott menüre is
   működik). Verziózott init-guard, hogy egy régi globális név ne blokkolja.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__maximaMenuV2Bound) return;
  window.__maximaMenuV2Bound = true;

  var DESKTOP = '(min-width: 1025px) and (hover: hover)';

  /* Index-alapú, komponensre scoped aktiválás. Minden híváskor teljesen
     újraállítja a gombok és panelek állapotát – NINCS korai is-active return. */
  function activateMenuCat(catBtn) {
    var menu = catBtn.closest('[data-maxima-menu]');
    if (!menu) return;
    var cats = Array.prototype.slice.call(menu.querySelectorAll('.maxima-menu__cat'));
    var panels = Array.prototype.slice.call(menu.querySelectorAll('.maxima-menu__panel'));
    var index = cats.indexOf(catBtn);
    if (index === -1) return;
    if (!panels[index]) return;

    cats.forEach(function (c, i) {
      var active = i === index;
      c.classList.toggle('is-active', active);
      c.setAttribute('aria-selected', active ? 'true' : 'false');
      c.tabIndex = active ? 0 : -1;
    });
    panels.forEach(function (p, i) {
      var active = i === index;
      p.classList.toggle('is-active', active);
      p.hidden = !active;
    });
  }

  function catFromEvent(e) {
    return (e.target && e.target.closest) ? e.target.closest('.maxima-menu__cat') : null;
  }

  /* Kattintás */
  document.addEventListener('click', function (e) {
    var cat = catFromEvent(e);
    if (cat) { activateMenuCat(cat); }
  });

  /* Hover desktopon. MOUSEOVER (bubble-öl → delegálható; a mouseenter NEM).
     relatedTarget: ne aktiváljon újra, amikor ugyanazon gomb belső span-jai
     között mozog az egér (a relatedTarget ilyenkor a gombon BELÜL van). */
  document.addEventListener('mouseover', function (e) {
    var cat = catFromEvent(e);
    if (!cat) return;
    if (!window.matchMedia(DESKTOP).matches) return;
    var from = e.relatedTarget;
    if (from && cat.contains(from)) return;
    activateMenuCat(cat);
  });

  /* Fókusz (Tab-billentyű): a focusin bubble-öl, így delegálható. */
  document.addEventListener('focusin', function (e) {
    var cat = catFromEvent(e);
    if (cat) { activateMenuCat(cat); }
  });

  /* Billentyűzet: Enter/Space aktivál; nyilak/Home/End navigál és aktivál. */
  document.addEventListener('keydown', function (e) {
    var cat = catFromEvent(e);
    if (!cat) return;
    var menu = cat.closest('[data-maxima-menu]');
    if (!menu) return;
    var cats = Array.prototype.slice.call(menu.querySelectorAll('.maxima-menu__cat'));
    var i = cats.indexOf(cat);
    var next = null;
    switch (e.key) {
      case 'Enter':
        /* A fő kategória tab valódi <a href> (saját collection URL). Enteren
           HAGYJUK navigálni – ne preventDefault-oljunk. (Egérrel a click/hover
           handler sem állítja meg a navigációt.) Nem-anchor esetén aktiválunk. */
        if (cat.tagName === 'A' && cat.getAttribute('href')) { return; }
        e.preventDefault(); activateMenuCat(cat); return;
      case ' ': case 'Spacebar':
        /* Space: panel-előnézet navigáció nélkül (az alkategóriák megjelennek). */
        e.preventDefault(); activateMenuCat(cat); return;
      case 'ArrowDown': case 'ArrowRight': next = cats[(i + 1) % cats.length]; break;
      case 'ArrowUp':   case 'ArrowLeft':  next = cats[(i - 1 + cats.length) % cats.length]; break;
      case 'Home': next = cats[0]; break;
      case 'End':  next = cats[cats.length - 1]; break;
      default: return;
    }
    e.preventDefault();
    if (next) { activateMenuCat(next); next.focus(); }
  });
})();
